a.item.display.video = (function(){
	var my = {
		popup:function(o){
			var o = o || {};
			var iid = o.iid || null;
			var token = a.popup.create({
				slideFrom:'fromleft',
				title:'Item video',
				css_class:'',
				ready:function(token){
					tpl.run({
						tpl:'/tpl/item/display/video/page.ejs?v='+v,
						data:{},
						cb:function(c){
							$('#popupid_'+token+'>.ic').empty().append(c).ready(function(){
								// Load videos
								my.loadVideos(iid,token);
							});
						}
					});
				}
			});
		},
		loadVideos:function(iid,token){
			var win = $('#popupid_'+token);
			$.ajax({
				type:'GET',
				url:'/api/item/file/video/list/',
				data:{
					iid:iid,
					token:localStorage.getItem('token'),
					accountname:localStorage.getItem('accountname')
				},
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success) {
						tpl.run({
							tpl:'/tpl/item/display/video/list.ejs?v='+v,
							data:result,
							cb:function(c){
								$('div[data-area="videolist"]',win).empty().append(c).ready(function(){
									
								});
							}
						});
					}
					else {
						a.s.growl.create('Error','Unable to perform operation',{});
					}
				}
			});
		}
	}
	return my;
}());